// From https://chakra-ui.com/community/recipes/using-fonts

import { Global } from "@emotion/react";

const Fonts = () => (
  <Global
    styles={`
/* TBISans */

/* 200 = thin */
@font-face {
  font-family: 'TBISans';
  font-style: normal;
  font-weight: 200;
  font-display: swap;
  src: url('/assets/fonts/TBISans-Thin.otf') format('opentype');
}

@font-face {
  font-family: 'TBISans';
  font-style: italic;
  font-weight: 200;
  font-display: swap;
  src: url('/assets/fonts/TBISans-ThinItalic.otf') format('opentype');
}

/* 300 = light */
@font-face {
  font-family: 'TBISans';
  font-style: normal;
  font-weight: 300;
  font-display: swap;
  src: url('/assets/fonts/TBISans-Light.otf') format('opentype');
}

@font-face {
  font-family: 'TBISans';
  font-style: italic;
  font-weight: 300;
  font-display: swap;
  src: url('/assets/fonts/TBISans-LightItalic.otf') format('opentype');
}

/* 400 = regular */
@font-face {
  font-family: 'TBISans';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url('/assets/fonts/TBISans-Regular.otf') format('opentype');
}

@font-face {
  font-family: 'TBISans';
  font-style: italic;
  font-weight: 400;
  font-display: swap;
  src: url('/assets/fonts/TBISans-Italic.otf') format('opentype');
}

/* 500 = medium */
@font-face {
  font-family: 'TBISans';
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src: url('/assets/fonts/TBISans-Medium.otf') format('opentype');
}

@font-face {
  font-family: 'TBISans';
  font-style: italic;
  font-weight: 500;
  font-display: swap;
  src: url('/assets/fonts/TBISans-MediumItalic.otf') format('opentype');
}

/* 600 = semibold */
@font-face {
  font-family: 'TBISans';
  font-style: normal;
  font-weight: 600;
  font-display: swap;
  src: url('/assets/fonts/TBISans-SemiBold.otf') format('opentype');
}

@font-face {
  font-family: 'TBISans';
  font-style: italic;
  font-weight: 600;
  font-display: swap;
  src: url('/assets/fonts/TBISans-SemiBoldItalic.otf') format('opentype');
}

/* 700 = bold */
@font-face {
  font-family: 'TBISans';
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url('/assets/fonts/TBISans-Bold.otf') format('opentype');
}

@font-face {
  font-family: 'TBISans';
  font-style: italic;
  font-weight: 700;
  font-display: swap;
  src: url('/assets/fonts/TBISans-BoldItalic.otf') format('opentype');
}

/* 800 = extrabold */
@font-face {
  font-family: 'TBISans';
  font-style: normal;
  font-weight: 800;
  font-display: swap;
  src: url('/assets/fonts/TBISans-ExtraBold.otf') format('opentype');
}

@font-face {
  font-family: 'TBISans';
  font-style: italic;
  font-weight: 800;
  font-display: swap;
  src: url('/assets/fonts/TBISans-ExtraBoldItalic.otf') format('opentype');
}

/* 900 = black */
@font-face {
  font-family: 'TBISans';
  font-style: normal;
  font-weight: 900;
  font-display: swap;
  src: url('/assets/fonts/TBISans-Black.otf') format('opentype');
}

@font-face {
  font-family: 'TBISans';
  font-style: italic;
  font-weight: 900;
  font-display: swap;
  src: url('/assets/fonts/TBISans-BlackItalic.otf') format('opentype');
}
    `}
  />
);

export default Fonts;
